<template>
  <div v-if="!store.isSetupComplete && !store.loading && canManageSetup" class="fixed bottom-4 left-4 z-50">
    <div class="bg-white rounded-lg shadow-xl border-l-4 border-orange-500 p-2.5 flex items-center gap-2.5 animate-fade-in">
      <div class="flex-shrink-0">
        <span class="flex items-center justify-center h-8 w-8 rounded-full bg-orange-100 text-orange-500">
          <i class="pi pi-exclamation-triangle text-base"></i>
        </span>
      </div>
      <div>
        <h3 class="font-semibold text-gray-800 text-sm">Setup Incomplete</h3>
        <p class="text-xs text-gray-600">Complete school setup to get started.</p>
      </div>
      <button @click="store.openWizard()"
        class="ml-1.5 bg-orange-500 hover:bg-orange-600 text-white text-xs font-medium py-1.5 px-3 rounded-full transition-colors">
        Continue Setup
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSchoolSetupStore } from '@/store/schoolSetupStore';
import { useUserStore } from '@/store/userStore';
import { can, AppPermissions } from '@/utils/permissions';

const store = useSchoolSetupStore();
const userStore = useUserStore();

const canManageSetup = computed(() => can(userStore.currentUser, AppPermissions.SchoolProfile.Actions.Update, AppPermissions.SchoolProfile.Resource));
</script>

<style scoped>
.animate-fade-in {
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
